<template>
    <discount-pix v-if="discountPix()"
    >
        <b>{{discountPix()}}% OFF</b> no PIX
    </discount-pix>
</template>

<script>
import {getDiscountPix} from '../../services/product'
import { mapState } from 'vuex'
import { CDiscountPix } from '../Styles/Product/styled';

export default {
    name: 'DiscountPix',
    components: {
        'discount-pix': CDiscountPix
    },
    methods: {
        discountPix() {
            return getDiscountPix(this.company)
        }
    },
    computed: {
        ...mapState("company", [
            "company"
        ])
    }
}
</script>

<style>

</style>
